import HTTP from './axios';

const CouponsService = {
  validate: (calendarId, patientId, coupon) => HTTP.post('/coupons/validate', {
    calendarId, patientId, coupon,
  }).then(response => response.data.data),
};

export default CouponsService;
